import React from 'react';
import PropTypes from 'prop-types';
import { ConditionalLink, UniversalLink, Icon } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import dummyImage from 'volto-fzj-internet/icons/dummy-image.png';
import TagSvg from '@plone/volto/icons/tag.svg';
import { useSelector } from 'react-redux';
import { FormattedDate } from '@plone/volto/components';
import { isInternalURL } from '@plone/volto/helpers/Url/Url';
import config from '@plone/volto/registry';

const BlogPostListing = ({ items, linkMore, isEditMode }) => {
  let link = null;
  let href = linkMore?.href || '';
  const language = useSelector((state) => state.intl.locale);
  const Image = config.getComponent('Image').component;

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink
        to={flattenToAppURL(href)}
        condition={!isEditMode}
        className="ui button"
      >
        {linkMore?.title || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href}>{linkMore?.title || href}</a>;
  }

  return (
    <>
      <div className="news-listing-template image">
        <div className="items">
          {items.map((item) => (
            <div key={item.UID} className="event-item">
              <div className="content">
                <div className="listing-item" key={item['@id']}>
                  <div className="image-wrapper">
                    {item.image_field ? (
                      <Image
                        item={item}
                        imageField={item.image_field}
                        alt={item.title}
                        loading="lazy"
                        responsive={false}
                        sizes="190px"
                      />
                    ) : (
                      <Image src={dummyImage} />
                    )}
                  </div>
                  <div className="text">
                    <div className="listing-body">
                      <div className="dates">
                        {item?.EffectiveDate !== 'None' && item?.effective && (
                          <FormattedDate
                            date={item.effective}
                            format={{
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric',
                            }}
                            locale={language}
                          />
                        )}
                        {/* Don't remove the curly braces because it indicate space */}
                        {item?.post_authors?.length > 0 && (
                          <span className="head-title">
                            {item?.post_authors?.map(
                              (author, index, authors) => (
                                <>
                                  <UniversalLink href={author.url}>
                                    {author.title}
                                  </UniversalLink>
                                  {index !== authors.length - 1 && <>,&nbsp;</>}
                                </>
                              ),
                            )}
                          </span>
                        )}
                        {/* Can be uncommented and exchanged with topics when we have an additional field for topics
                          {item?.subjects.length >= 1 ? (
                            <span className="topics">
                              {item.subjects.slice(0, 3).map((item, i) => {
                                return i <= 1 ? item + ', ' : item;
                              })}
                            </span>
                          ) : (
                            <span></span>
                          )} */}
                      </div>
                    </div>

                    <ConditionalLink
                      to={flattenToAppURL(item['@id'])}
                      condition={!isEditMode}
                    >
                      <div className="listing-body">
                        <h2>{item.title ? item.title : item.id}</h2>
                        <p className="description">{item?.description}</p>
                      </div>
                    </ConditionalLink>

                    <span className="tags-container">
                      {item?.post_tags?.length > 0 && (
                        <>
                          <span className="tag-icon">
                            <Icon name={TagSvg} size={15} />
                          </span>
                          {item?.post_tags?.map((tag, index, postTags) => (
                            <span className="tag-item">
                              <UniversalLink href={tag.url}>
                                {tag.title}
                              </UniversalLink>
                              {index !== postTags.length - 1 && <>,&nbsp;</>}
                            </span>
                          ))}
                        </>
                      )}
                    </span>

                    {item?.subjects && item.subjects?.length >= 1 ? (
                      <div className="tags">
                        {item.subjects.map((item, i) => {
                          return (
                            <ConditionalLink
                              to={`/search?Subject=${item}`}
                              condition={!isEditMode}
                            >
                              {item}
                            </ConditionalLink>
                          );
                        })}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        {link && <div className="block-footer">{link}</div>}
      </div>
    </>
  );
};
BlogPostListing.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};
export default BlogPostListing;
